
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"26","height":"26"}},[_c('path',{attrs:{"d":"M23.997 1.592l.822.816-10.593 10.676 10.59 10.505-.816.822-10.797-10.71-10.795 10.71-.816-.822 10.59-10.505L1.588 2.408l.823-.816L13.202 12.47 23.997 1.592z","fill":"#404040","fill-rule":"nonzero"}})])
      }
    
      }
    